import './storeList.css';

function StoreListItem(props) {
    const data = props.data;
    return (
        <div itemScope={true} itemType={'https://schema.org/LocalBusiness'} ref={props.ref} className={'storelist-items-container'}>
            <a itemProp={'url'} className={'block-link'} href={data.link}>
                <div className={'storelist-item-img storelist-item'}>
                    <img loading={'lazy'} itemProp={'image'}  src={data.sl_preview ? data.sl_preview.large[0] : "https://via.placeholder.com/600/000000/f0b849?text=No+image"} alt={data.sl_preview.lat}/>
                </div>
                <div className={'storelist-item-description storelist-item'}>
                    <div className={'storelist-item-description-container storelist-item-description-address-container'}>
                        <div itemProp={'name'} className={'storelist-item-description-container-title storelist-item-description-address-container-title'}>{data.title.rendered}</div>
                        <div itemProp={'address'} className={'storelist-item-description-text'}>{data.sl_address}</div>
                    </div>
                    <div className={'storelist-item-description-container storelist-item-description-schedule-container'}>
                        <div className={'storelist-item-description-container-title storelist-item-description-schedule-container-title'}>Horaires d'ouverture</div>
                        <div className={'storelist-item-description-schedule'}>
                            <div className={`storelist-item-description-schedule-status ${data.sl_today_schedule ? (data.sl_today_schedule.open_now ? 'open' : 'close') : 'close'}`}>
                                {data.sl_today_schedule ? (data.sl_today_schedule.open_now ? 'Ouvert' : 'Bientôt ouvert') : 'Bientôt ouvert'}
                            </div>
                            {data.sl_today_schedule ?
                                <div className={'storelist-item-description-schedule-today'}>
                                    Aujourd'hui : {data.sl_today_schedule.store_schedule_hour.map(
                                    (e,i) => {
                                        return (
                                            <span key={'store_hour'+i}>
                                                {e.store_schedule_open_hour} - {e.store_schedule_close_hour}
                                                {i+1 !== data.sl_today_schedule.store_schedule_hour.length ? '\x20&\x20' : ''}
                                            </span>
                                        )
                                    }
                                )}
                                </div>
                                : ''
                            }

                        </div>
                    </div>

                </div>
            </a>

            <div className={'storelist-item-infos storelist-item'}>
                <div className={'storelist-item-infos-title'}>{data.sl_hook[1].content && data.sl_hook[1].content.length > 1 ? 'Moyens' : 'Moyen'} de livraison</div>
                {
                    data.sl_hook[1].content ?
                        <div className={`storelist-item-infos-deliverys ${data.sl_hook[1].content.length < 2 ? 'storelist-item-infos-deliverys-center' : ''}`}>
                            {data.sl_hook[1].content.map((e,i)=>{
                                return (
                                    <div itemProp={'service'} itemScope={true} itemType={'https://schema.org/Service'} key={'hook_delivery'+i} className={'storelist-item-infos-deliverys-item'}>
                                        <a itemProp={'url'} href={e.href ? e.href : "#"} target={'_blank'}>
                                            <img loading={'lazy'} itemProp={'logo'} src={e.img_url ? e.img_url : "https://via.placeholder.com/120/000000/f0b849?text=No+image"} alt=""/>
                                        </a>
                                    </div>
                                )
                            })}
                        </div> : 'Aucun moyen de livraison pour le moment'
                }
            </div>
        </div>
    )
}

export default StoreListItem;
